import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { GuideStepMedia } from '../../components/GuideStepMedia';

export default function VAGuideStepsPanel({ guide, onClose }) {
  const steps = guide?.steps || [];

  return (
    <div className="mt-4 rounded-xl border-2 border-indigo-200 dark:border-indigo-700 bg-indigo-50/50 dark:bg-indigo-950/30 overflow-hidden">
      <div className="flex items-start justify-between gap-3 px-4 py-3 border-b border-indigo-200/80 dark:border-indigo-800 bg-white/80 dark:bg-gray-900/80">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-indigo-600 dark:text-indigo-400">Guide</p>
          <h5 className="font-semibold text-slate-900 dark:text-white">{guide.title}</h5>
          {guide.description && (
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{guide.description}</p>
          )}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="flex-shrink-0 rounded-lg p-1.5 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            aria-label="Close guide"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        )}
      </div>

      <div className="px-4 py-4 space-y-6 max-h-[70vh] overflow-y-auto">
        {steps.length === 0 && (
          <p className="text-sm text-slate-500">No steps in this guide yet.</p>
        )}
        {steps.map((step, idx) => (
          <div key={step._id || idx} className="flex gap-3">
            <div className="flex-shrink-0 w-9 h-9 rounded-full bg-gradient-to-br from-indigo-600 to-violet-600 text-white flex items-center justify-center font-bold text-sm shadow-sm">
              {idx + 1}
            </div>
            <div className="flex-1 min-w-0">
              <h6 className="font-medium text-slate-900 dark:text-white">
                {step.title || `Step ${idx + 1}`}
              </h6>
              {step.body && (
                <p className="mt-2 text-sm text-slate-600 dark:text-slate-300 whitespace-pre-wrap leading-relaxed">
                  {step.body}
                </p>
              )}
              <GuideStepMedia step={step} alt={step.title || `Step ${idx + 1}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
